var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSummary(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 127.194 127.194",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 127.194 127.194"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fa0"
    },
    d: "M125.29,48.948c-0.988-3.049-3.615-5.27-6.784-5.718l-32.733-4.768L71.132,8.792 c-1.41-2.86-4.335-4.679-7.534-4.679c-3.199,0-6.123,1.818-7.535,4.679l-14.64,29.671L8.687,43.23 c-3.169,0.448-5.794,2.669-6.785,5.718C0.92,51.987,1.737,55.33,4.03,57.557l23.692,23.081l-5.599,32.613 c-0.542,3.152,0.754,6.336,3.345,8.221c2.601,1.871,6.024,2.126,8.854,0.629l29.276-15.383l29.276,15.383 c1.229,0.652,2.571,0.971,3.909,0.971c1.742,0,3.478-0.535,4.943-1.6c2.589-1.885,3.884-5.068,3.343-8.221l-5.599-32.613 l23.691-23.081C125.455,55.33,126.276,51.987,125.29,48.948z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffd00b"
    },
    d: "M63.597,4.113c-3.198,0.002-6.122,1.818-7.534,4.679l-14.64,29.671L8.687,43.23 c-3.169,0.448-5.794,2.669-6.785,5.718C0.92,51.987,1.737,55.33,4.03,57.557l23.692,23.081l-5.599,32.613 c-0.542,3.152,0.754,6.336,3.345,8.221c2.601,1.871,6.024,2.126,8.854,0.629l29.275-15.383V4.113z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ff8f8f"
    },
    cx: 63.597,
    cy: 68.766,
    r: 21.931
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff1a1a"
    },
    d: "M85.528,68.766c0,9.277-9.819,16.8-21.931,16.8c-12.112,0-21.931-7.522-21.931-16.8 c0-9.275,9.818-16.797,21.931-16.797C75.708,51.969,85.528,59.491,85.528,68.766z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M41.666,68.766c0,12.113,9.818,21.932,21.931,21.932c12.111,0,21.931-9.818,21.931-21.932H41.666z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8e5ea"
    },
    d: "M63.597,85.566c12.111,0,21.931-7.522,21.931-16.8H41.666 C41.666,78.044,51.485,85.566,63.597,85.566z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#33363a"
    },
    d: "M126.717,48.486c-1.175-3.626-4.241-6.209-7.995-6.74l-31.954-4.654L72.477,8.129 c-1.652-3.351-5.137-5.516-8.879-5.516c-3.741,0-7.227,2.165-8.88,5.515L40.427,37.092l-31.95,4.653 c-3.757,0.532-6.823,3.114-8.002,6.742c-1.151,3.564-0.166,7.547,2.508,10.145L26.11,81.162l-5.465,31.835 c-0.643,3.74,0.867,7.452,3.947,9.693c1.743,1.254,3.774,1.891,5.813,1.891c1.577,0,3.158-0.381,4.615-1.152l28.579-15.016 l28.573,15.014c1.413,0.75,3.007,1.146,4.612,1.146c2.112,0,4.126-0.652,5.826-1.887c3.071-2.236,4.58-5.948,3.938-9.688 l-5.465-31.835l23.125-22.529C126.887,56.03,127.872,52.047,126.717,48.486z M83.952,70.266 c-0.773,10.566-9.595,18.932-20.355,18.932s-19.582-8.366-20.355-18.932H83.952z M43.242,67.266 c0.773-10.565,9.595-18.93,20.355-18.93s19.581,8.365,20.355,18.93H43.242z M122.116,56.483L98.424,79.564 c-0.354,0.345-0.515,0.841-0.432,1.328l5.599,32.613c0.448,2.606-0.605,5.195-2.746,6.753c-2.079,1.51-4.985,1.729-7.273,0.515 l-28.475-14.962V92.285c0-0.048-0.01-0.093-0.014-0.139c12.23-0.77,21.945-10.959,21.945-23.38c0-12.919-10.511-23.43-23.431-23.43 s-23.431,10.511-23.431,23.43c0,12.421,9.715,22.61,21.945,23.38c-0.004,0.046-0.014,0.091-0.014,0.139v13.528L33.62,120.776 c-2.328,1.232-5.116,1.032-7.27-0.516c-2.144-1.56-3.197-4.147-2.749-6.754l5.599-32.613c0.083-0.487-0.078-0.984-0.432-1.328 L5.075,56.482c-1.864-1.811-2.549-4.586-1.747-7.07c0.822-2.527,2.956-4.327,5.575-4.697l32.736-4.768 c0.488-0.071,0.911-0.378,1.129-0.821l14.64-29.67c1.152-2.334,3.582-3.843,6.19-3.843c2.609,0,5.038,1.508,6.189,3.842 l14.641,29.671c0.218,0.443,0.641,0.75,1.129,0.821l32.74,4.769c2.615,0.37,4.749,2.169,5.567,4.695 C124.668,51.893,123.983,54.669,122.116,56.483z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#a7bbc1"
    },
    cx: 63.597,
    cy: 71.279,
    r: 7.252
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#fff"
    },
    cx: 63.597,
    cy: 68.814,
    r: 7.252
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8e5ea"
    },
    d: "M58.469,73.942c-2.831-2.832-2.831-7.424,0-10.256c2.832-2.832,7.424-2.832,10.255,0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#33363a"
    },
    d: "M63.597,77.561c-2.241,0-4.482-0.853-6.188-2.558c-3.412-3.413-3.412-8.965-0.001-12.377 c1.653-1.653,3.851-2.563,6.189-2.563c2.338,0,4.535,0.911,6.188,2.563c3.412,3.412,3.412,8.965,0,12.377 C68.079,76.708,65.838,77.561,63.597,77.561z M63.597,63.062c-1.537,0-2.981,0.598-4.067,1.685c-2.242,2.243-2.242,5.892,0,8.135 c2.243,2.242,5.892,2.242,8.133,0c2.243-2.242,2.243-5.892,0-8.134h0C66.577,63.66,65.133,63.062,63.597,63.062z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummary);
export default __webpack_public_path__ + "static/media/summary.4ca01193de3db33a6a53b2489e8bc71a.svg";
export { ForwardRef as ReactComponent };